module.exports = __webpack_public_path__ + "static/media/male-guard_1f482-200d-2642-fe0f.0801eb34.png";